import React from 'react';

export default class QuestionUI extends React.Component {
    renderQuestionNumber() {
        return (
            <div className="question-number-container">
                <div className="question-number">{this.props.questionNumber}</div>
            </div>
        );
    }

    renderPoints() {
        if (!this.props.isTestResults || typeof this.props.points === "undefined") return;
        return <div className="point-value">{this.props.points} {this.props.points === 1 ? 'point' : 'points'}</div>;
    }

    renderQuestion() {
        let imageRow;

        if (this.props.image) {
            imageRow = (
                <div className="row">
                    <div className="col-12 d-flex justify-content-center">
                        <a href={this.props.image} target="_blank">
                            <img className="question-image img-fluid" src={this.props.image}
                                 alt={this.props.imageAltText}/>
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="question-text" dangerouslySetInnerHTML={{__html: this.props.question}} />
                    </div>
                </div>
                {imageRow}
            </div>
        );
    }

    render() {
        let groupedClass = this.props.inGroup ? ' grouped' : '';

        return (
            <div className={"question" + groupedClass}>
                {this.renderPoints()}
                {this.renderQuestionNumber()}
                {this.renderQuestion()}
            </div>
        );
    }
}
